import { Button, message, Modal, Popconfirm, Table, TablePaginationConfig, Tag } from "antd";
import { ColumnType } from "antd/es/table";
import { useState } from "react";
import { BaseDepartment } from "../../features/integration-setting-table/DepartmentsTable/department.type";
import { useGetIspringDepartmentsQuery, useRemoveIspringDepartmentMutation, useUpdateIspringDepartmentMutation } from "../../store/api/departmentApi";
import { DeleteOutlined, PoweroffOutlined } from "@ant-design/icons";

export const ISpringDepartmentPage = () => {
    const { data: departments } = useGetIspringDepartmentsQuery({});
    const [removeDepartment] = useRemoveIspringDepartmentMutation();
    const [updateDepartment] = useUpdateIspringDepartmentMutation();
    const [pagination, setPagination] = useState({
        page_number: 1,
        page_size: 10,
    });

    const handleDelete = (code: string) => {
        Modal.confirm({
            title: 'Вы уверены, что хотите удалить этот отдел?',
            content: 'Это действие нельзя отменить.',
            okText: 'Да',
            okType: 'danger',
            cancelText: 'Нет',
            onOk: async () => {
                try {
                    await removeDepartment(code).unwrap();
                    message.success('Отдел успешно удален');
                } catch (error) {
                    message.error('Не удалось удалить отдел');
                }
            },
        });
    };

    const handleEnable = async (id: string) => {
        Modal.confirm({
            title: 'Вы уверены, что хотите активировать этот отдел?',
            content: 'После активации отдел будет доступен в системе.',
            okText: 'Да',
            okType: 'primary',
            cancelText: 'Нет',
            onOk: async () => {
                try {
                    await updateDepartment(id).unwrap();
                    message.success('Отдел успешно активирован');
                } catch (error) {
                    message.error('Не удалось активировать отдел');
                }
            },
        });
    };

    const columns = [
        {
            title: 'Название',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Статус',
            dataIndex: 'enabled',
            key: 'enabled',
            render: (enabled: boolean) => (
                <Tag color={enabled ? 'green' : 'red'}>
                    {enabled ? 'Включен' : 'Отключен'}
                </Tag>
            ),
        },
        {
            title: 'Действия',
            key: 'actions',
            render: (_: any, record: BaseDepartment) => (
                record.enabled ? (
                    <Button
                        danger
                        onClick={() => handleDelete(record.id)}
                        icon={<DeleteOutlined />}
                        title="Удалить отдел"
                    />
                ) : (
                    <Button
                        type="primary"
                        onClick={() => handleEnable(record.id)}
                        icon={<PoweroffOutlined />}
                        title="Активировать отдел"
                    />
                )
            ),
        },
    ];

    const handleTableChange = (newPagination: TablePaginationConfig) => {
        setPagination({
            page_number: newPagination.current || 1,
            page_size: newPagination.pageSize || 10,
        });
    };

    return (
        <div>
            <h1>Департаменты iSpring</h1>
            <Table
                columns={columns as ColumnType<BaseDepartment>[]}
                dataSource={departments?.data}
                rowKey="id"
                pagination={{
                    current: pagination.page_number,
                    pageSize: pagination.page_size,
                    total: departments?.data.length,
                }}
                onChange={handleTableChange}
                bordered
            />
        </div>
    );
};
